import React from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';

import './BadgingProgressUI.css'
import ContinueButton from './ContinueButton';
import { globals } from '../../misc/globals';

const BadgingProgressUI = (props: UIProperties<BadgingProgressUIConfig>) => {
	
	var star1: boolean = false;
	var star2: boolean = false;
	var star3: boolean = false;
	var star4: boolean = false;
	var star5: boolean = false;

	if(props.parameters.starsAwarded >= .2) {
		star1 = true;
	}
	if(props.parameters.starsAwarded >= .4) {
		star2 = true;
	}
	if(props.parameters.starsAwarded >= .6) {
		star3 = true;
	}
	if(props.parameters.starsAwarded >= .8) {
		star4 = true;
	}
	if(props.parameters.starsAwarded === 1) {
		star5 = true;
	};

	const fadeOut = (onDone: () => void) => {
		const el = document.getElementById(props.id);

		el.classList.remove('fade-in-animation');
		el.classList.add('fade-out-animation');

		setTimeout(() => {
			onDone();
		}, 500);
	};

	const onContinueClicked = () => {
		fadeOut(() => {
			props.parameters.onContinueClicked();
		})
	}

	const onRetryClicked = () => {
		fadeOut(() => {
			props.parameters.onRetryClicked();
		})
	}

	const onLevel2Clicked = () => {
		fadeOut(() => {
			props.parameters.onLevel2Clicked();
		})
	}

	const getStar508 = () => {
		var star = 0;

		if(star5) {
			star = 5;
		} else if (star4) {
			star = 4;
		} else if (star3) {
			star = 3;
		} else if (star2) {
			star = 2;
		} else if (star1) {
			star = 1;
		}

		return `${star} out of 5 stars`;
	};
	
	return (
		<div id={props.id} className="in-game-ui-container ui-top-most-container modal-bg fade-in-animation modal-disable-select">
			{props.parameters.finalDebrief ? (<div>
				<div className="debrief-final-container center-on-container">
					<img src="./assets/images/general/components/debrief/debrief-container.png"/>
					{props.parameters.level1 ? (<div>
						<div className="debrief-final-desc-container">

							<p tabIndex={0} id='first-object-badgingProgress' className="debrief-title">Great Job!</p>
							<p tabIndex={0} className="debrief-sub-title">You Finished Level 1 And Earned The Following Badges</p>
							<img tabIndex={0} aria-label='anaphylaxis' className="debrief-icon-1" src="./assets/images/general/badges/level1/badge_anaphylaxis_down.png"/>
							<img tabIndex={0} aria-label='intracranial pressure' className="debrief-icon-2" src="./assets/images/general/badges/level1/badge_intracranial_pressure_down.png"/>
							<img tabIndex={0} aria-label='splenectomy' className="debrief-icon-3" src="./assets/images/general/badges/level1/badge_splenectomy_down.png"/>
							<img tabIndex={0} aria-label='turp' className="debrief-icon-4" src="./assets/images/general/badges/level1/badge_turp_down.png"/>
							<p tabIndex={0} className="debrief-final-points">{'Care Score: ' + props.parameters.playerScore + '/' + props.parameters.maxScore}</p>

							<div className="debrief-final-stars-container">
								<div tabIndex={0} aria-label={getStar508()} className="center-on-container">
									<img className="debrief-final-stars" src={star1 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star2 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star3 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star4 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star5 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
								</div>
							</div>	

							<GeneralButtonWithText parameters= {{
								srcIdle: './assets/images/general/buttons/button_submit_main.png',
								srcHighlight: './assets/images/general/buttons/button_submit_down.png',
								highlightOnHover: true,
								text: 'Retry Visit',
								top: '600px',
								left: '50px',
								width: '350px',
								onClicked: onRetryClicked
							}}/>
							
							<GeneralButtonWithText parameters= {{
								srcIdle: './assets/images/general/buttons/button_submit_main.png',
								srcHighlight: './assets/images/general/buttons/button_submit_down.png',
								highlightOnHover: true,
								text: 'Level 2',
								top: '600px',
								left: '425px',
								width: '350px',
								onClicked: onLevel2Clicked
							}}/>
							

							<GeneralButtonWithText parameters= {{
								id: 'last-object-badgingProgress',
								srcIdle: './assets/images/general/buttons/button_submit_main.png',
								srcHighlight: './assets/images/general/buttons/button_submit_down.png',
								highlightOnHover: true,
								text: 'Exit To Envelope',
								top: '600px',
								left: '800px',
								width: '350px',
								onClicked: onContinueClicked
							}}/>
						</div>
					</div>):(<div>
						<div className="debrief-final-desc-container">

							<p tabIndex={0} id='first-object-badgingProgress' className="debrief-title">Great Job!</p>
							<p tabIndex={0} className="debrief-sub-title">You Finished Level 2 And Earned The Following Badges</p>
							<img tabIndex={0} aria-label='sepsis' className="debrief-icon-1" src="./assets/images/general/badges/level2/badge_sepsis_down.png"/>
							<img tabIndex={0} aria-label='air embolism' className="debrief-icon-2" src="./assets/images/general/badges/level2/badge_air_embolism_down.png"/>
							<img tabIndex={0} aria-label='diagnostic hysteroscopy' className="debrief-icon-3" src="./assets/images/general/badges/level2/badge_diagnostic_hysteroscopy_down.png"/>
							<img tabIndex={0} aria-label='chest tube' className="debrief-icon-4" src="./assets/images/general/badges/level2/badge_chest_tube_down.png"/>
							<p tabIndex={0} className="debrief-final-points">{'Care Score: ' + props.parameters.playerScore + '/' + props.parameters.maxScore}</p>

							<div className="debrief-final-stars-container">
								<div tabIndex={0} aria-label={getStar508()} className="center-on-container">
									<img className="debrief-final-stars" src={star1 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star2 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star3 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star4 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
									<img className="debrief-final-stars" src={star5 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
								</div>
							</div>	
							<GeneralButtonWithText parameters= {{
								srcIdle: './assets/images/general/buttons/button_submit_main.png',
								srcHighlight: './assets/images/general/buttons/button_submit_down.png',
								highlightOnHover: true,
								text: 'Retry Visit',
								top: '600px',
								left: '50px',
								width: '500px',
								onClicked: onRetryClicked
							}}/>
							<GeneralButtonWithText parameters= {{
								id: 'last-object-badgingProgress',
								srcIdle: './assets/images/general/buttons/button_submit_main.png',
								srcHighlight: './assets/images/general/buttons/button_submit_down.png',
								highlightOnHover: true,
								text: 'Exit To Envelope',
								top: '600px',
								left: '650px',
								width: '500px',
								onClicked: onContinueClicked
							}}/>
							
						</div>
					</div>)}
				</div>
			</div>):(<div>
				<div className="debrief-container center-on-container">
					<img src="./assets/images/general/components/debrief/debrief-container.png"/>
					<div className="debrief-desc-container">

						<p tabIndex={0} id='first-object-badgingProgress' className="debrief-title">Good Job!</p>
						<p tabIndex={0} className="debrief-sub-title">You Finished Your Visit</p>
						<p tabIndex={0} className="debrief-points">{'Care Score: ' + props.parameters.playerScore + '/' + props.parameters.maxScore}</p>

						<div className="debrief-stars-container">
							<div tabIndex={0} aria-label={getStar508()} className="center-on-container">
								<img className="debrief-stars" src={star1 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
								<img className="debrief-stars" src={star2 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
								<img className="debrief-stars" src={star3 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
								<img className="debrief-stars" src={star4 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
								<img className="debrief-stars" src={star5 ? ("./assets/images/general/components/debrief/star_lit.png") : ("./assets/images/general/components/debrief/star_unlit.png")}/>
							</div>
						</div>	
						<GeneralButtonWithText parameters= {{
							srcIdle: './assets/images/general/components/debrief/button_sbar_submit_main.png',
							srcHighlight: './assets/images/general/components/debrief/button_sbar_submit_down.png',
							highlightOnHover: true,
							text: 'Retry Visit',
							top: '380px',
							left: '60px',
							width: '190px',
							onClicked: onRetryClicked
						}}/>
						<GeneralButtonWithText parameters= {{
							id: 'last-object-badgingProgress',
							srcIdle: './assets/images/general/components/debrief/button_sbar_submit_main.png',
							srcHighlight: './assets/images/general/components/debrief/button_sbar_submit_down.png',
							highlightOnHover: true,
							text: 'Continue',
							top: '380px',
							left: '550px',
							width: '190px',
							onClicked: onContinueClicked
						}}/>
						
					</div>
				</div>
			</div>)}

			<audio src="./assets/audio/Badge_Unlock.mp3" playsInline={true} autoPlay={!globals.isMuted} controls={false}></audio>

		</div>
	);

};

export interface BadgingProgressUIConfig extends BaseConfig{
	playerScore?: number;
	maxScore?: number;
	starsAwarded?: number;
	finalDebrief?: boolean;
	level1?: boolean;
	onContinueClicked: () => void;
	onRetryClicked: () => void;
	onLevel2Clicked?: () => void;
}

export default BadgingProgressUI;